import { Grid, Stack, Typography, useTheme } from "@mui/material";
import { Gauge, gaugeClasses } from '@mui/x-charts/Gauge';

const DigitalStudioSteps = ({
    list
}) => {
    const theme = useTheme();

    return (
        <>
            <Grid
                direction='row'
                justifyContent='center'
                alignItems='start'
                container
                spacing={{xs: 3, md: 6}}
                width='100%'
                pb={{xs: 5, md: 10}}
            >
                {
                    list.map((item, index) => {
                        return <Grid
                            key={index}
                            size={{xs: 6, md: 3}}
                        >
                            <Stack
                                direction='column'
                                justifyContent='start'
                                alignItems='center'
                                position='relative'
                            >
                                <Gauge
                                    width={125}
                                    height={125}
                                    value={item.fill}
                                    cornerRadius="50%"
                                    sx={(theme) => ({
                                        [`& .${gaugeClasses.valueText}`]: {
                                            fontSize: 40,
                                            fontFamily: theme.typography.fontFamily,
                                            display: 'none'
                                        },
                                        [`& .${gaugeClasses.valueArc}`]: {
                                            fill: theme.palette.primary.main,
                                        },
                                        [`& .${gaugeClasses.referenceArc}`]: {
                                            fill: theme.palette.background.paper,
                                        },
                                    })}
                                />

                                <Typography
                                    fontWeight={600}
                                    fontSize={24}
                                    textAlign='left'
                                    color={theme.palette.text.primary}
                                    lineHeight={1.5}
                                    position='absolute'
                                    top={45}
                                >
                                    {`0${index + 1}`}
                                </Typography>

                                <Typography
                                    fontWeight={600}
                                    fontSize={{xs: 12, md: 16}}
                                    textAlign='left'
                                    color={theme.palette.text.primary}
                                    lineHeight={1.5}
                                    pt={{xs: 1, md: 3}}
                                    pb={{xs: 0.5, md: 1}}
                                >
                                    {item.label}
                                </Typography>
                                    
                                <Typography
                                    fontWeight={500}
                                    fontSize={{xs: 12, md: 12}}
                                    textAlign="center"
                                    lineHeight={1.5}
                                    color={theme.palette.text.secondary}
                                >
                                    {item.description}
                                </Typography>
                            </Stack>
                        </Grid>
                    })
                }
            </Grid>
        </>
    );
}

export default DigitalStudioSteps;